import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { AppContext, AccountFeatures } from '@lightspeed-invoicing/core-client/frontend';
import ConfirmButton from "../common/button/confirmbutton.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import { Redirect } from "react-router-dom";
import { getEventName } from '../name-helpers/eventNameHelper'
import CalendarModal from "../calendar/modals/CalendarModal.component.jsx";
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component'
import NewPriceListModal from '../price-list/components/NewPriceListModal';
import PriceListService from '../state/price-list/PriceListService';
import { getPriceListName } from '../name-helpers/priceListNameHelper';

class EditEvent extends Component {
    constructor(props, context) {
        super(props, context)
        const { id } = this.props.calendarEvent
        this.state = {
            calendarEventId: id,
            showModal: false,
            redirect: '',
            statusLoading: false,
        }

        this.deleteCalendarEvent = this.deleteCalendarEvent.bind(this)
        this.openCalendarModal = this.openCalendarModal.bind(this)
        this.togglePriceListModal = this.togglePriceListModal.bind(this)
        this.createPriceList = this.createPriceList.bind(this)
    }

    createPriceList = async (title, objectType) => {
        this.setState({
            statusLoading: true
        })
        const res = await PriceListService.CreatePriceListFromEvent(
            title,
            objectType,
            this.state.calendarEventId,
        )
        this.setState({
            statusLoading: false,
            redirect: <Redirect to={{ pathname: `/price-lists/${res.getId()}/edit` }} />
        })
    }

    togglePriceListModal(event) {
        event?.preventDefault()
        this.setState({
            statusLoading: false,
            showModal: !this.state.showModal,
        })
    }

    deleteCalendarEvent(e) {
        e.preventDefault()
        AppContext.getApiClient().delete(`/calendar-events/${this.state.calendarEventId}`).then(() => {
            let timer = setTimeout(() => {
                this.setState({
                    redirect: <Redirect to={{ pathname: '/calendar-events/listing' }} />
                })
            }, 800)
        })
    }


    openCalendarModal(event) {
        event.preventDefault()

        const onModalCloseCallback = () => {
            this.setState({
                modal: '',
            }, () => {
                if (this.props.onRefresh) {
                    this.props.onRefresh()
                }
            })
        }

        this.setState({
            modal: <CalendarModal
                calendarEventId={this.state.calendarEventId}
                onClose={onModalCloseCallback}
            />
        })
    }

    render() {
        const deleteButton = this.state.calendarEventId ?
            <ConfirmButton
                onModalRender={(m, c) => { this.setState({ modal: m }, c) }}
                message={
                    <FormattedMessage
                        id="calendar_event.delete_warning"
                        defaultMessage="Are you sure you want to delete this {eventName} ? It will be removed from your calendar."
                        values={{ eventName: getEventName(this.props.intl) }}
                    />
                }
                onClick={this.deleteCalendarEvent}
                className="btn btn-outline-danger mr-2 mb-2"
            >
                <Icon value={"trash"} className={"mr-1"} />
                <FormattedMessage
                    id="quote.analytics.delete_btn"
                    defaultMessage="Delete"
                />
            </ConfirmButton> : '';


        const createPricelistButton = this.state.calendarEventId &&
            <div className='mb-4'>
                <ButtonWrapper
                    accountFeatureKey={AccountFeatures.FeaturePriceList}
                    onClick={(e) => this.togglePriceListModal(e)}
                    redirectToAccount={true}
                    className={"btn btn-primary w-100"}
                    protectedClassName={"btn btn-primary w-100"}
                    premium={false}
                >
                    <span>
                        <Icon value={"plus-circle"} className={"mr-1"} />
                        <FormattedMessage
                            id="calendar_event.price_list_add_btn"
                            defaultMessage="New {priceList}"
                            values={{ priceList: getPriceListName(this.props.intl) }}
                        />
                    </span>
                </ButtonWrapper>
            </div>
        const { identifier } = this.props.calendarEvent.attributes
        return (

            <div>
                {this.state.modal}
                {this.state.redirect}
                <NewPriceListModal
                    show={this.state.showModal}
                    onHide={this.togglePriceListModal}
                    onCreate={this.createPriceList}
                    isLoading={this.state.statusLoading}
                    objectType={'credit-memo'}
                    title={identifier}
                />
                <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                    <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                        <div className="col-12 ui-module sticky-bottom-module">
                            <div className="row justify-content-between">
                                <div className="col-6">
                                    {deleteButton}
                                    <button className={'btn btn-outline-primary mr-2 mb-2'} onClick={this.openCalendarModal}>
                                        <Icon value={"pen-alt"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="quote.analytics.edit_btn"
                                            defaultMessage="Edit"
                                        />
                                    </button>
                                </div>
                                <div className="col-auto">
                                    {createPricelistButton}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >


        );

    }

}

export default injectIntl(EditEvent)



// WEBPACK FOOTER //
// ./src/scheduling-page/editevent.component.jsx